import { createContext } from 'react';

import { User, emptyUser } from 'types/User';

export interface Auth {
  token: string;
}

export interface GlobalContext {
  hasContext: boolean;
  setHasContext: (newHasContext: boolean) => void;
  isMobile?: boolean;
  path: string;
  host: string;
  containerContext: {
    user: User;
    setUser: (newUser: User) => void;
    auth: Auth;
    setAuth: (newAuth: Auth) => void;
  };
}

const defaultContextValues: GlobalContext = {
  hasContext: false,
  setHasContext: () => {},
  path: '',
  host: '',
  containerContext: {
    user: emptyUser,
    setUser: () => {},
    auth: {
      token: '',
    },
    setAuth: () => {},
  },
};

export const globalContext = createContext<GlobalContext>(defaultContextValues);
